<template>
  <div>
    <b-row>
      <b-col cols="3" sm="2">
        <b-img v-if="commentDetails.collaboratorProfilePictureUrl" class="profile-picture"
               :src="commentDetails.collaboratorProfilePictureUrl" rounded="circle"
               alt="User profile picture"></b-img>

        <b-img v-else class="profile-picture" :src="require('../../../../src/assets/default_profile.png')"
               rounded="circle" alt="Circle image"></b-img>
      </b-col>
      <b-col>
        <p class="collaborator-name-text">{{ commentDetails.collaboratorName }}</p>
        <p class="comment-content-text">{{ commentDetails.commentContent }}</p>
        <p class="comment-creation-time-text">Commented on {{ formattedCommentTime }}</p>
      </b-col>
    </b-row>
    <hr>
  </div>
</template>

<script>
  export default {
    name: "CommentCell",
    props: {
      commentDetails: Object
    },
    data() {
      return {
        formattedCommentTime: null
      }
    },
    mounted() {
      // convert the format of the comment date
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
      ];

      const taskDueDate = new Date(this.commentDetails.commentCreationTime)
      const year = taskDueDate.getFullYear()
      const month = monthNames[taskDueDate.getMonth()]
      const day = taskDueDate.getDate()

      this.formattedCommentTime = month + ' ' + day + ', ' + year + ' at ' + taskDueDate.getHours() + ':' + taskDueDate.getMinutes()
    }
  }
</script>

<style scoped>
  .profile-picture {
    width: 4.5em;
    height: 4.5em;
  }

  .collaborator-name-text {
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  .comment-content-text {
    margin-bottom: 0.5em;
    border: 1px solid #212441;
    padding: 0.5em;
  }

  .comment-creation-time-text {
    font-size: 0.9em;
    margin-bottom: 0;
    font-style: italic;
  }
</style>
